import { ColorType } from "@/theme/colors";

export const DEFAULT_MAX_WIDTH = 420;
export const DEFAULT_TOP_RATIO = 0.24;
export const DEFAULT_CARD_WIDTH = 700;
export const DEFAULT_BACKDROP_ANIMATION_DURATION = 200;
export const DEFAULT_INVISIMODAL_BACKDROP_OPACITY = 0;
export const DEFAULT_BACKDROP_OPACITY = 0.5;
export const DEFAULT_INVISIMODAL_BACKDROP_BLUR = 0;
export const DEFAULT_BACKDROP_BLUR = 8;
export const DEFAULT_CONTAINER_BACKDROP_BLUR = 6;
export const DEFAULT_CARD_Y_OFFSET = 32;
export const SCROLLABLE_FADE_SIZE = 80;
export const CARD_STACK_GAP = 14;
export const CONTENT_GAP = 18;
export const DEFAULT_CONTAINER_PADDING_TOP = "1rem";
export const DEFAULT_SCROLLABLE_PADDING = "2rem 0";
export const CSS_FULL = "100%";
export const CSS_FIT_CONTENT = "fit-content";
// The overlay paint is a gradient layer over a fully-transparent colour layer.
// `background-image` only accepts the image layer, so the colour is a separate
// longhand (the `background` shorthand is banned by
// `local-rules/no-background-style-shorthand`).
export const INVISIMODAL_OVERLAY_BACKGROUND_IMAGE =
  "linear-gradient(160deg, rgba(0, 85, 51, 0.75) 0%, rgb(0, 14, 42) 25%, rgb(0, 0, 0) 100%)";
export const INVISIMODAL_OVERLAY_BACKGROUND_COLOR = "rgba(0, 0, 0, 0)";
export const INVISIMODAL_TRANSPARENT_BACKGROUND = "transparent";
export const INVISIMODAL_NO_BACKGROUND_IMAGE = "none";
export const INVISIMODAL_NO_SHADOW = "none";
export const INVISIMODAL_NO_FILTER = "none";
export const DEFAULT_BOX_SHADOW =
  "#ffffff29 1px 0.9px 8.1px 1px inset, #00000033 0px 7px 11.5px -4px inset, #00000021 1px -4px 14px 0px";

export const INVISIMODAL_CONTAINER_COLOR = ColorType.Transparent;
